import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { AdGroupTypeColumn as AdGroupTypeColumnConfig } from '@bingads-webui-campaign/ad-groups-data';

export class AdGroupTypeColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('AdGroupType_Label');

    super({
      ...AdGroupTypeColumnConfig,
      title,
      sortable: 'AdGroupType',
      type: 'string',
      helpId: 'pop_BA_DSA_AdGroupType',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.i18n = i18n;
  }
  pickProperty(item) {
    return item.AdGroupType !== 'Unknown' && item.AdGroupType != null && item.AdGroupType !== 'HotelAds' ?
      this.i18n.getString(`AdGroupType_${item.AdGroupType}`) :
      '-';
  }
}
